import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'export',
    position: [
        ButtonPosition.arrayTableOperate,
        ButtonPosition.tableToolArea,
        ButtonPosition.tableBatchArea,
        window?.__page__?.siteName || window?.siteInfo?.appName === 'Apollo2.0'
            ? ButtonPosition.tableOperate
            : null,
    ],
    action: () => { },
};
